import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { Placement } from '@core/placements-types';
import { DateComponent } from '@core/time-ui';
import { AvatarComponent, HeadingComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-disqualified-tooltip',
  standalone: true,
  templateUrl: './candidate-disqualified-tooltip.component.html',
  styleUrl: './candidate-disqualified-tooltip.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadingComponent,
    TranslatePipe,
    MomentModule,
    DateComponent,
    IconComponent,
    AvatarComponent,
  ],
})
export class CandidateDisqualifiedTooltipComponent {
  private readonly i18n = inject(I18nService);

  public placement = input.required<Placement>();

  protected disqualifiedBy = computed(() =>
    this.placement().disqualifyKind === 'system' ? 'system' : this.placement().disqualifiedByUser,
  );

  protected disqualifiedByName = computed(() => {
    if (this.disqualifiedBy() === 'system') {
      return this.i18n.translate('app.search.table.knockout_question');
    }

    const user = this.placement().disqualifiedByUser;

    if (!user?.id) {
      return '';
    }

    if (user!.firstName === null && user!.lastName === null) {
      return this.i18n.translate('app.common.deleted_user');
    }

    return `${user!.firstName} ${user!.lastName}`;
  });
}
